import * as actionTypes from "../../Actions/actionTypes";

const initialState = {
  isStandard: false,
  selectedBBPlan: null,
  selectedServiceList: [],
  selectedPlan: null,
};

const updatePlan = (state, plan) => {
  return { ...state, ...plan };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PLAN:
      return updatePlan(state, action.plan);

    default:
      return state;
  }
};

export default reducer;
